module.exports = __webpack_public_path__ + "img/refresh.0de6c839.svg";